"use client";

import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FilterPill {
  label: string;
  onRemove: () => void;
}

interface CommunityFilterPillsProps {
  filters: FilterPill[];
  onClearAll: () => void;
}

export function CommunityFilterPills({
  filters,
  onClearAll,
}: CommunityFilterPillsProps) {
  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mt-5 pt-4 border-t border-line/60">
      {filters.map((filter) => (
        <span
          key={filter.label}
          className="inline-flex items-center gap-1 bg-brand-green-soft text-brand-green px-3 py-1 rounded-full text-sm"
        >
          {filter.label}
          <button
            type="button"
            onClick={filter.onRemove}
            aria-label={`Remove ${filter.label} filter`}
            className="font-bold"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </span>
      ))}
      <Button variant="ghost" size="sm" onClick={onClearAll}>
        Clear filters
      </Button>
    </div>
  );
}
